import React, { useState, Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import Byline from './byline'
import NavTop from './navtop'
import ScrollDown from './scrolldown'
import { pubdateString, moddateString } from './component-helpers/datehelpers'
import * as topperStyles from '../../styles/modules/topper.module.less'
import ShareButtons from './sharebuttons'

const Topper = ({ meta, Title, Deck }) => {
  const {
    PROJECT: { AUTHORS, ISO_MODDATE, ISO_PUBDATE, SUBFOLDER, MARKET_KEY },
  } = meta
  
  const [mobile, setMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (typeof window !== "undefined" && window.innerWidth < 768) {
        setMobile(true);
      } else if (typeof window !== "undefined" && window.innerWidth > 768) {
        setMobile(false);
      }
    }
    window.addEventListener('resize', handleResize)
    //initial check if we're on a small screen
    handleResize();
  }, [])
  let topperIlloUrl = meta.PROJECT.MARKET_KEY === 'Houston' || meta.PROJECT.MARKET_KEY === 'SanAntonio' || meta.PROJECT.MARKET_KEY ===  'Texcom' ? 'https://files.sfchronicle.com/legistracker/bill_tracker_illo_5.jpeg' : mobile ? 'https://files.sfchronicle.com/static-assets/compression-bot/square.hearst.legislature.transparent_'+meta.PROJECT.MARKET_KEY+'.svg' : 'https://files.sfchronicle.com/static-assets/compression-bot/wide.hearst.legislature.transparent_'+meta.PROJECT.MARKET_KEY+'.svg'
  let topperIlloClass = meta.PROJECT.MARKET_KEY === 'Houston' || meta.PROJECT.MARKET_KEY === 'SanAntonio' || meta.PROJECT.MARKET_KEY ===  'Texcom' ? topperStyles.illoWrapper : topperStyles.illoWrapperOld
  return (
    <Fragment>
      <NavTop meta={meta} />
      <header className={topperStyles.header}>
        <div className={topperIlloClass}>
            <img  alt="" src={topperIlloUrl} />
          </div>
        
        <section
          aria-label="Topper headline, deck, byline and dateline"
          className={topperStyles.textContainer}
        >
          {/* <span className={topperStyles.kicker}>{meta.PROJECT.PUB_NAME}</span> */}
          <h1 className={topperStyles.hed}>{Title}</h1>
          <h2 className={topperStyles.dek}>{Deck}</h2>
          <div className={topperStyles.dateby}>
            <span>By</span>
            {AUTHORS.map((author, index) => {
              // Pass special flag if this is the last item
              let isLast = false
              if (index === AUTHORS.length - 1) {
                isLast = true
              }
              // Add the bylines
              return (
                <Byline
                  key={author.AUTHOR_NAME}
                  url={author.AUTHOR_PAGE}
                  name={author.AUTHOR_NAME}
                  index={index}
                  isLast={isLast}
                />
              )
            })}
            &nbsp;|&nbsp;
            <time
              className="topper-dateline"
              dateTime={ISO_PUBDATE}
              itemProp="datePublished"
            >
              {pubdateString}
            </time>
            {moddateString && (
              <Fragment>
                &nbsp;|&nbsp;
                <time
                  className="topper-dateline updated-date"
                  dateTime={ISO_MODDATE}
                  itemProp="dateModified"
                >
                  Updated: {moddateString}
                </time>
              </Fragment>
            )}
            <div className="articleHeader--shareTools">
            <div className="share-list" id="sharebutton-wrapper">
              <ShareButtons meta={meta}/>
            </div>
</div>
          </div>
        </section>
      </header>
    </Fragment>
  )
}

Topper.propTypes = {
  meta: PropTypes.object.isRequired,
}

export default Topper
